<template>
  <v-card dark hover raised style="margin: 5px 0px;">
    <v-flex>{{ classInfo }}</v-flex>
  </v-card>
</template>

<script>
  export default {
    props: ["classItem"],
    data() {
      return {
        id: this.classItem.id,
        day: this.classItem.day,
        dayAbbrev: this.classItem.dayAbbrev,
        description: this.classItem.description,
        period: this.classItem.period,
        time: this.classItem.time,
        title: this.classItem.title
      };
    },
    computed: {
      classInfo() {
        const title = this.title;
        const time = this.time;
        const period = this.period;
        return this.time + this.period + " | " + this.title;
      }
    }
  };
</script>

<style>
</style>